module.exports = __webpack_public_path__ + "img/acaki5.51d75ad5.jpg";